import { RVLoadingTitle } from "@regal-voice/ui";

import { LoadingTitleSize } from "./shared";

/**
 * Display a skeleton while loading, and then the provided JSX.element children when loaded.
 * Basically just a more convienent {@link LoadingTitle}
 *
 * @param size - From the enum LoadingTitleSize; width to render this skeleton
 * @param loading - Loading state of element
 * @param children - Child elements to display when loading is complete
 *
 * @returns JSX.Element (Loading skeleton or children elements if loading is false)
 */
export function DynamicLoadingTitle({
    size = LoadingTitleSize.MEDIUM,
    loading = true,
    children,
}: {
    size?: LoadingTitleSize;
    loading: boolean;
    children: JSX.Element;
}): JSX.Element {
    return loading ? <RVLoadingTitle size={size} /> : children;
}
